// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__Sloq4","title":"PageHeader_title__YDhmh","subtitle":"PageHeader_subtitle__9M7NJ"};